export default {
  ADD_PRODUCTS: 'ADD_PRODUCT',
  ACTIVE_LIST: 'ACTIVE_LIST',
  BIN_LIST: 'BIN_LIST',
  BAR_LIST: 'BAR_LIST',
};
